import DataTable, { TableColumn } from 'react-data-table-component';

import customStyles from './../../components/FilterDataTable/CustomTableStyles';
import CustomExpander from './../../components/FilterDataTable/CustomExpander/CustomExpander';

import Pagination from 'components/Common/Pagination';
import Search from 'components/Search/Search';

interface FilterVisitReportListTable<T> {
  columns: TableColumn<T>[];
  data: T[];
  totalPages: number;
  isLoading: boolean;
  onChangePage: (page: number) => void;
  onChangeFilterParams: (ordering: string) => void;
  onChangeSearch: (search: string) => void;
  page: number;
  expandableRows?: boolean;
  expandableRowsComponent?: React.FC<{ data: T }>;
  expandableRowsComponentProps?: {
    slug: string;
  };
}

function FilterDataTable<T>({
  columns,
  data,
  totalPages,
  onChangeFilterParams,
  onChangePage,
  onChangeSearch,
  isLoading,
  page,
  expandableRows = false,
  expandableRowsComponent,
  expandableRowsComponentProps,
}: FilterVisitReportListTable<T>) {
  const handleFilter = async (column: TableColumn<any>, sortDirection: 'asc' | 'desc') => {
    if (column.sortField && sortDirection) {
      onChangeFilterParams(sortDirection === 'asc' ? column.sortField : `-${column.sortField}`);
      onChangePage(1);
    }
  };
  return (
    <div className="p-3">
      <div className="d-flex align-items-center justify-content-between mb-3 flex-wrap gap-2">
        <div>
          <Search
            onSearch={search => {
              onChangeSearch(search);
              onChangePage(1);
            }}
          />
        </div>
      </div>
      <DataTable
        columns={columns}
        data={data}
        progressPending={isLoading}
        sortServer
        onSort={handleFilter}
        customStyles={customStyles}
        dense
        expandableRows={expandableRows}
        expandableRowsComponent={expandableRowsComponent}
        expandableRowsComponentProps={expandableRowsComponentProps}
        expandableIcon={{
          collapsed: <CustomExpander isExpanded={false} />,
          expanded: <CustomExpander isExpanded />,
        }}
      />
      <Pagination
        page={page}
        setPage={(page: number) => onChangePage(page)}
        count={totalPages}
        limit={10}
        loading={isLoading}
      />
    </div>
  );
}

export default FilterDataTable;
